// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__bNN_s","bold":"style_bold__aYb4Y","disc":"style_disc__SrCOu"};